import { render, staticRenderFns } from "./CoreDrag.vue?vue&type=template&id=986fc82a&"
import script from "./CoreDrag.vue?vue&type=script&lang=js&"
export * from "./CoreDrag.vue?vue&type=script&lang=js&"
import style0 from "./CoreDrag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports